module.exports = __webpack_public_path__ + "static/media/bunker-intro-2021.2528764d.mp4";